module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA00lEQVQ4ja3RoU4DQRRA0bObMXWkDleDrCJBIUgVohKHIVWklqoSBD+AxAGKfsCS1CCAYOoQNa0kpB+AIwRSBBU0sLvDps++OXeSmSTLMjhAHxuW5wE7fk+CTTwFdHCBGa7x8ePgKAef4xDtgBO8oInXP0AevsFtigaGFfAe3tPF8q0KhrQAleKYQCGOCewX4ZjAHY5ycBePoSQww1nObgvbMY9YOCsL1CrYgHmKZ+xi7R+4jhamAae4xBj3+Iy4uYV19AKuFujY978nJYE5Juhh8AUplDQz0EyXQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edit.png
// module id = KzIr
// module chunks = 2